import * as React from 'react';
import classNames from 'classnames';
import './pageHeader.module.scss';

type Props = {
    title: any;
    subTitle: string;
    showOnMobile?: boolean;
};

export class PageHeader extends React.Component<Props> {
    render() {
        const { title, subTitle, showOnMobile = false } = this.props;
        return (
            <div styleName={classNames('page-header', { 'show-mobile': showOnMobile })}>
                <div styleName="title">{title}</div>
                <div styleName="sub-title">{subTitle}</div>
            </div>
        );
    }
}
